import { Server, Response } from 'miragejs';

const ago = (seconds: number): string => new Date(Date.now() - seconds * 1000).toISOString();

const DEVICES = [
  // ── Hospital Central ▸ Clínica Norte ─────────────────────────────────────
  {
    id: 1,
    device_type: 'TV',
    nickname: 'Sala de Espera 1',
    app_version: '1.7.13',
    last_heartbeat_at: ago(45),
    is_ws_connected: true,
    has_audio_output: true,
    ip_address: '192.168.1.10',
    os_platform: 'linux',
    created_at: ago(86400 * 30),
    status: 'online',
    account_id: 'account-1',
    account_name: 'Clínica Norte',
    parent_account_id: 'parent-1',
    parent_account_name: 'Hospital Central',
  },
  {
    id: 2,
    device_type: 'KIOSK',
    nickname: 'Kiosko Entrada',
    app_version: '1.7.13',
    last_heartbeat_at: ago(30),
    is_ws_connected: true,
    has_audio_output: null,
    ip_address: '192.168.1.11',
    os_platform: 'win32',
    created_at: ago(86400 * 30),
    status: 'online',
    account_id: 'account-1',
    account_name: 'Clínica Norte',
    parent_account_id: 'parent-1',
    parent_account_name: 'Hospital Central',
  },
  {
    id: 3,
    device_type: 'TV',
    nickname: 'Sala de Espera 2',
    app_version: '1.7.13',
    last_heartbeat_at: ago(120),
    is_ws_connected: true,
    has_audio_output: false,
    ip_address: '192.168.1.12',
    os_platform: 'linux',
    created_at: ago(86400 * 25),
    status: 'warning',
    account_id: 'account-1',
    account_name: 'Clínica Norte',
    parent_account_id: 'parent-1',
    parent_account_name: 'Hospital Central',
  },
  // ── Hospital Central ▸ Clínica Sur ───────────────────────────────────────
  {
    id: 4,
    device_type: 'TV',
    nickname: '',
    app_version: '1.7.13',
    last_heartbeat_at: ago(55),
    is_ws_connected: true,
    has_audio_output: true,
    ip_address: '10.0.1.20',
    os_platform: 'linux',
    created_at: ago(86400 * 20),
    status: 'online',
    account_id: 'account-2',
    account_name: 'Clínica Sur',
    parent_account_id: 'parent-1',
    parent_account_name: 'Hospital Central',
  },
  {
    id: 5,
    device_type: 'KIOSK',
    nickname: 'Kiosko Principal',
    app_version: '1.7.12',
    last_heartbeat_at: ago(3600 * 2),
    is_ws_connected: false,
    has_audio_output: null,
    ip_address: null,
    os_platform: 'win32',
    created_at: ago(86400 * 20),
    status: 'offline',
    account_id: 'account-2',
    account_name: 'Clínica Sur',
    parent_account_id: 'parent-1',
    parent_account_name: 'Hospital Central',
  },
  {
    id: 6,
    device_type: 'COFFEE_ROOM',
    nickname: 'Sala de Café',
    app_version: '1.7.13',
    last_heartbeat_at: ago(90),
    is_ws_connected: true,
    has_audio_output: null,
    ip_address: '10.0.1.25',
    os_platform: 'linux',
    created_at: ago(86400 * 15),
    status: 'online',
    account_id: 'account-2',
    account_name: 'Clínica Sur',
    parent_account_id: 'parent-1',
    parent_account_name: 'Hospital Central',
  },
  // ── Grupo Médico del Este ▸ Consultorios Este ─────────────────────────────
  {
    id: 7,
    device_type: 'TV',
    nickname: 'Pantalla Principal',
    app_version: '1.7.13',
    last_heartbeat_at: ago(20),
    is_ws_connected: true,
    has_audio_output: true,
    ip_address: '172.16.0.5',
    os_platform: 'darwin',
    created_at: ago(86400 * 10),
    status: 'online',
    account_id: 'account-3',
    account_name: 'Consultorios Este',
    parent_account_id: 'parent-2',
    parent_account_name: 'Grupo Médico del Este',
  },
  {
    id: 8,
    device_type: 'TV',
    nickname: 'Sala de Espera B',
    app_version: '1.7.11',
    last_heartbeat_at: ago(300),
    is_ws_connected: true,
    has_audio_output: true,
    ip_address: '172.16.0.6',
    os_platform: 'darwin',
    created_at: ago(86400 * 10),
    status: 'online',
    account_id: 'account-3',
    account_name: 'Consultorios Este',
    parent_account_id: 'parent-2',
    parent_account_name: 'Grupo Médico del Este',
  },
  // ── Grupo Médico del Este ▸ Consultorios Oeste ────────────────────────────
  {
    id: 9,
    device_type: 'TV',
    nickname: '',
    app_version: '1.7.12',
    last_heartbeat_at: ago(86400),
    is_ws_connected: false,
    has_audio_output: null,
    ip_address: null,
    os_platform: 'linux',
    created_at: ago(86400 * 5),
    status: 'offline',
    account_id: 'account-4',
    account_name: 'Consultorios Oeste',
    parent_account_id: 'parent-2',
    parent_account_name: 'Grupo Médico del Este',
  },
  // ── No parent ▸ Clínica Independiente ────────────────────────────────────
  {
    id: 10,
    device_type: 'TV',
    nickname: 'TV Recepción',
    app_version: '1.7.11',
    last_heartbeat_at: ago(3600),
    is_ws_connected: true,
    has_audio_output: true,
    ip_address: '192.168.50.1',
    os_platform: 'linux',
    created_at: ago(86400 * 60),
    status: 'online',
    account_id: 'account-5',
    account_name: 'Clínica Independiente',
    parent_account_id: null,
    parent_account_name: null,
  },
  {
    id: 11,
    device_type: 'KIOSK',
    nickname: 'Kiosko Sala',
    app_version: '1.7.13',
    last_heartbeat_at: ago(40),
    is_ws_connected: true,
    has_audio_output: null,
    ip_address: '192.168.50.2',
    os_platform: 'win32',
    created_at: ago(86400 * 60),
    status: 'warning',
    account_id: 'account-5',
    account_name: 'Clínica Independiente',
    parent_account_id: null,
    parent_account_name: null,
  },
];

const DEVICES_PAGE_SIZE = 5;

const wlDevicesRoutes = (server: Server): void => {
  server.get('/waiting_lists_v2/comet/devices', (_, request) => {
    const page = Math.max(1, Number(request.queryParams.page) || 1);
    const totalPages = Math.ceil(DEVICES.length / DEVICES_PAGE_SIZE);
    const start = (page - 1) * DEVICES_PAGE_SIZE;
    return {
      count: DEVICES.length,
      next: page < totalPages ? `?page=${page + 1}` : null,
      previous: page > 1 ? `?page=${page - 1}` : null,
      results: DEVICES.slice(start, start + DEVICES_PAGE_SIZE),
    };
  });

  server.patch('/waiting_lists_v2/comet/devices/:id/nickname', (_, request) => {
    const body = JSON.parse(request.requestBody) as { nickname: string };
    const device = DEVICES.find((d) => d.id === Number(request.params.id));
    if (!device) return new Response(404);
    device.nickname = body.nickname;
    return { nickname: body.nickname };
  });

  server.post('/waiting_lists_v2/waiting_lists/refresh_tv', () => new Response(200));
};

export default wlDevicesRoutes;
